/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Csjensblank_Staatsexamen_Lehramt30Inputs */

const en__field_enum_csjensblank_staatsexamen_lehramt30 = /** @type {(inputs: _Field_Enum_Csjensblank_Staatsexamen_Lehramt30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Staatsexamen Lehramt`)
};

const de__field_enum_csjensblank_staatsexamen_lehramt30 = /** @type {(inputs: _Field_Enum_Csjensblank_Staatsexamen_Lehramt30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Staatsexamen Lehramt`)
};

/**
* | output |
* | --- |
* | "Staatsexamen Lehramt" |
*
* @param {_Field_Enum_Csjensblank_Staatsexamen_Lehramt30Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_csjensblank_staatsexamen_lehramt30 = /** @type {((inputs?: _Field_Enum_Csjensblank_Staatsexamen_Lehramt30Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Csjensblank_Staatsexamen_Lehramt30Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_csjensblank_staatsexamen_lehramt30(inputs)
	return de__field_enum_csjensblank_staatsexamen_lehramt30(inputs)
});
export { _field_enum_csjensblank_staatsexamen_lehramt30 as "_field_enum_CSJENSBLANK_STAATSEXAMEN_LEHRAMT" }